module.exports = __webpack_public_path__ + "static/navigation-380a2d41764e738752161f65521d8cee.mp4";